import { render, staticRenderFns } from "./VariantInventoryRow.vue?vue&type=template&id=23aebce4"
import script from "./VariantInventoryRow.vue?vue&type=script&lang=js"
export * from "./VariantInventoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports